import { Locale, setDefaultOptions } from 'date-fns';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';

export interface DefaultOption {
  locale?: Locale;
}

export const setDateFnsDefaultLocale = async () => {
  // 관련 PR 맥락: https://github.com/modusign/modusign-client/pull/9939
  // 관련 PR 맥락: https://github.com/modusign/modusign-client/pull/10047

  setDefaultOptions({ locale: window.navigator.language.startsWith('en') ? en : ko });
};
